<template>
    <VJoyWrapper class="reviews-recommendations-indicator" no-margin column-gap="0" wrap="nowrap">
        <VJoyIcon name="thumbup" color="neutral-50" size="xsmall" />
        <VJoyLink
            class="reviews-recommendations-indicator__link"
            :class="{'reviews-recommendations-indicator__link--bold': mf}"
            @click="onRecommendationsClicked()"
        >
            {{ recommendationsCount }}
        </VJoyLink>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyIcon, VJoyWrapper, VJoyLink} from '@maltjoy/core-vue';
    import {useProfileTracking} from '~/composables/useProfileTracking';
    import {useScrollToElement} from '~/composables/useScrollToElement';
    import {anchorsPageProfile} from '~/config/anchors';
    import {ProfileSectionReachedSection, ProfileSectionReachedEntryPoint, ProfileSectionReachedContext} from '~/config/TrackingEvents';
    import {useProfileStore} from '~/store/profileStore';

    const props = defineProps<{
        recommendationsCount: number;
        mf?: boolean;
    }>();

    const {scrollToAnchor} = useScrollToElement();
    const {profile} = storeToRefs(useProfileStore());
    const {trackProfileSectionReached} = useProfileTracking();
    function onRecommendationsClicked() {
        scrollToAnchor(`#${anchorsPageProfile.recommendationsSection}`);
        trackProfileSectionReached(
            ProfileSectionReachedSection.RECOMMENDATIONS,
            ProfileSectionReachedEntryPoint.HEADER_THUMB_UP,
            profile.value?.profileId,
            profile.value?.accountId,
            props.mf ? ProfileSectionReachedContext.PROFILE_DRAWER : ProfileSectionReachedContext.PROFILE_PAGE,
        );
    }
</script>
<style scoped lang="scss">
    .reviews-recommendations-indicator {
        max-height: 18px;

        &__link {
            font-weight: var(--joy-font-weight-normal);
            white-space: nowrap;

            &--bold {
                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
